import Box from '@/common/components/Box';
import Button from '@/common/components/Button';
import { cn } from '@/common/utils/cn';
import DirectiveEntryExecutionEntryCompleted from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/DirectiveEntry/Entries/ExecutionEntry/content/ExecutionEntryCompleted';
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type';
import {
  MaintenanceForwardingDirectiveEntryStatus,
  MaintenanceForwardingStatus,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type';
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

interface MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntryProps {
  showCompleted?: boolean
}

const MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry = ({
  showCompleted,
}: MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntryProps) => {
  const { forwarding, forwardingUpdatedAt, noActions } =
    useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>()

  const navigate = useNavigate()

  const isAwaitingCheckin = useMemo(() => {
    return forwarding?.status === MaintenanceForwardingStatus.OnGoingCheckin
  }, [forwardingUpdatedAt])

  const isAwaitingEndOfMaintenance = useMemo(() => {
    return (
      !isAwaitingCheckin &&
      forwarding?.directive_entry?.status &&
      [
        MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
        MaintenanceForwardingDirectiveEntryStatus.InProgress,
      ].includes(forwarding?.directive_entry?.status)
    )
  }, [forwardingUpdatedAt])

  const isAwaitingClientReview = useMemo(() => {
    return (
      !isAwaitingEndOfMaintenance &&
      forwarding?.directive_entry?.status &&
      [MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview].includes(forwarding?.directive_entry?.status)
    )
  }, [forwardingUpdatedAt, isAwaitingEndOfMaintenance])

  const isCompleted = useMemo(() => {
    return (
      !isAwaitingClientReview &&
      forwarding?.directive_entry?.status &&
      [MaintenanceForwardingDirectiveEntryStatus.Completed].includes(forwarding?.directive_entry?.status)
    )
  }, [forwardingUpdatedAt, isAwaitingClientReview])

  return (
    <Box className={cn('p-4 flex flex-col gap-4', isAwaitingClientReview && 'bg-yellow-op-2')}>
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">Execução da manutenção</p>

          {isAwaitingEndOfMaintenance && (
            <div>
              <p className="text-warning text-xs">Aguardando estabelecimento finalizar a manutenção</p>
            </div>
          )}

          {isCompleted && (
            <div>
              <p className="text-valid text-xs">Concluído</p>
            </div>
          )}
        </div>

        {isAwaitingClientReview && !noActions && (
          <div>
            <Button
              onClick={() => navigate(`${forwarding.id}/execution/${forwarding?.directive_entry?.id}`)}
              operationKlassToCheckPermission="Client::Maintenance::Directive::ExecutionEntries::Advance"
            >
              Vistoria da manutenção
            </Button>
          </div>
        )}
      </div>

      {showCompleted && <DirectiveEntryExecutionEntryCompleted />}
    </Box>
  )
}

export default MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry
